export default __webpack_public_path__ + "static/media/doctor3.1b299be4.jpg";